angular.module('unergie.main')
.directive('submitListener', () =>
    ({
        restrict: 'A',
        require: 'ngModel',
        link(scope, elem, attrs, ngModelCtrl) {
            elem.on('keyup', ($event) => {
                if ($event.keyCode === 13) {
                    ngModelCtrl.$setViewValue(elem.val(), 'submit')
                }
            })
        },
    })
)
